import Modal from 'react-bootstrap/Modal';
import { PaymentOptions } from '../entries/PaymentOptions';

function DebtModal(props) {
    return (
        <>
        {props.user && <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Pony Up!!</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>Records indicate that you owe <strong>${props.user.debt}</strong> to the cause. Please pay your entry fees by:</p>
                <PaymentOptions />
                <p>If you just sent your money, give us a day or two to update our records.  Otherwise, if you
                    think this is an error, send an email to <a href="mailto:osuphil95@yahoo.com">Phil</a> and he'll clear it up.</p>
            </Modal.Body>
        </Modal>}
        </>
    );
}

export default DebtModal;